import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { CommonPipesModule } from '../common/commonpipes.module';
import { NgxTranslateModule } from '../translate/translate.module';
import { FaqRoutingModule } from './faq-routing.module';
import { FaqListingComponent } from './view-all-faq/faq-listing.component';
import { FaqSectionComponent } from './faq-list/faq-section.component';



@NgModule({
    declarations: [FaqListingComponent,FaqSectionComponent],
    imports: [
        NgbModule,
        CommonModule,
        FontAwesomeModule,
        NgxTranslateModule,
        RouterModule,
        FaqRoutingModule,
        CommonPipesModule,
        ReactiveFormsModule,
    ],
    exports: [FaqListingComponent,FaqSectionComponent]
})
export class FaqModule { }
